import { render } from "./RICreateReservation.vue?vue&type=template&id=6e47bec2&scoped=true"
import script from "./RICreateReservation.vue?vue&type=script&lang=js"
export * from "./RICreateReservation.vue?vue&type=script&lang=js"

import "./RICreateReservation.vue?vue&type=style&index=0&id=6e47bec2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e47bec2"]])

export default __exports__